module.exports = __webpack_public_path__ + "static/media/girl.5fb1e5a4.png";